module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAu0lEQVQYlX3RvU5CURAE4I8fQyRILAi0CMSYSCMNFbHQwo6Ch/AJpeIxSGgI0FDYoSZGyUUtXJIr8TLNnnN2sjOzh784Q1MGigf3W5xg9R85nzrf4RRJ1uRC1Ad84wldXKIWvdc0eRAKk3hbY4NPXEeGZ2zhMUs20McIxQLKIbuIZgVVfIX/NRpo5VKek7AyDMkEH3jDFPf7gHNcoIcdxnhBCXWc42pPhiXafnc/w3sEW4TKzWGYYz/Y+QEwUiK4upVswQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/previous.png
// module id = 3I81
// module chunks = 1